import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { STAGE_LABELS } from '../lib/stages';
import { Search, Loader2 } from 'lucide-react';

export function DealSearchSidebar({ onNavigate }) {
  const [q, setQ] = useState('');
  const [results, setResults] = useState(null);
  const [searching, setSearching] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (q.trim().length < 2) { setResults(null); setSearching(false); return; }
    setSearching(true);
    const t = setTimeout(() => {
      api.compareSearch(q.trim())
        .then(r => setResults(r.data || []))
        .catch(() => setResults([]))
        .finally(() => setSearching(false));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  const openDeal = (id) => {
    setQ('');
    navigate(`/projects/${id}`);
    if (onNavigate) onNavigate();
  };

  return (
    <div className="mb-2 relative">
      <div className="relative">
        <Search className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-blue-400" />
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="Deal suchen…"
          data-testid="sidebar-deal-search"
          className="w-full bg-secondary/40 border border-border rounded-sm pl-8 pr-2 h-9 text-xs text-foreground placeholder:text-muted-foreground/60 focus:outline-none focus:border-blue-500/50 transition-colors" />
      </div>
      {q.trim().length >= 2 && (
        <div className="absolute left-0 right-0 top-10 bg-card border border-border rounded-sm shadow-xl z-50 max-h-72 overflow-y-auto"
          data-testid="sidebar-deal-search-dropdown">
          {searching && !results ? (
            <div className="flex justify-center py-4"><Loader2 className="w-4 h-4 animate-spin text-muted-foreground" /></div>
          ) : (results || []).length === 0 ? (
            <p className="text-[11px] text-muted-foreground text-center py-4 px-2">Kein Deal gefunden.</p>
          ) : (
            results.map((r, i) => (
              <button key={r.id} onClick={() => openDeal(r.id)} data-testid={`sidebar-deal-result-${i}`}
                className="w-full text-left px-3 py-2.5 hover:bg-secondary/50 active:bg-secondary/70 border-b border-border/40 last:border-b-0 transition-colors">
                <p className="text-xs text-foreground font-medium truncate">{r.name}</p>
                <p className="text-[11px] text-muted-foreground truncate mt-0.5">
                  {[r.random_project_name, STAGE_LABELS[r.pipeline_stage] || r.pipeline_stage,
                    typeof r.phase1_score === 'number' ? `P1 ${r.phase1_score}/${r.phase1_max}` : null,
                  ].filter(Boolean).join(' · ') || '—'}
                </p>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
